import { __rest } from 'tslib';
import React from 'react';
import { styled, Link, LazyImage } from '@teko/ui';

const Text = styled.div((props) => `
flex: 1;
font-size: 0.75rem;
margin-top: auto;
margin-bottom: auto;
margin-left: 0.5rem;
text-decoration: ${props.disableProductPromo ? 'line-through' : 'none'};
`);
const Wrapper = styled.div `
  display: flex;
  background: #fff;
  cursor: pointer;
`;
const ImageWrapper = styled.div `
  display: flex;
  align-items: center;
`;
const Gift = (_a) => {
    var { image, text, link, disableProductPromo, cartLineSelected = true, border = true } = _a, props = __rest(_a, ["image", "text", "link", "disableProductPromo", "cartLineSelected", "border"]);
    if (link)
        return (React.createElement(Link, { href: link },
            React.createElement(Wrapper, Object.assign({}, props),
                React.createElement(ImageWrapper, null,
                    React.createElement(LazyImage, Object.assign({ contain: true, height: 32, width: 32, border: border }, image, { borderRadius: 2 }))),
                React.createElement(Text, { disableProductPromo: disableProductPromo }, text))));
    return (React.createElement(Wrapper, Object.assign({}, props),
        React.createElement(ImageWrapper, null,
            React.createElement(LazyImage, Object.assign({ contain: true, height: 32, width: 32, border: border }, image, { borderRadius: 2 }))),
        React.createElement(Text, { disableProductPromo: disableProductPromo && cartLineSelected }, text)));
};

export { Gift as G };
